const LIST_QUERY = `
  query ListTransactions(
      $username: String,
      $paginationParams: PaginationInput!,
      $fromDate: DateTime,
      $toDate: DateTime
    ) {
    listTransactions(username: $username,
      pagination: $paginationParams,
      fromDate: $fromDate,
      toDate: $toDate) {
      objects {
        cardUUID
        username
        firstName
        lastName
        createdAt
        updatedAt
        readerId
        readerName
        isValid
        status
      }
      totalRows
    }
  }
`

const CREATE_MUTATION = `
  mutation CreateTransaction($username: String!) {
    createTransaction(params: {
      username: $username,
      type: Stepup
    }) {
      username
      isValid
      error
    }
  }
`

const transactionQueries = {
  methods: {
    async createTransaction(username) {
      try {
        const result = await this.graphQuery(CREATE_MUTATION, {username})
        if (result.createTransaction.error) {
          throw new Error(result.createTransaction.error)
        }
        return result.createTransaction
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default transactionQueries
